import React from "react";
import "./Blue_Outline_Btn.css";
import { Button } from "react-bootstrap";

const Blue_Outline_Btn = ({ btnText, onClick }) => {
  return (
    <Button className="Blue_Outline_Btn" onClick={onClick}>
      {btnText}
    </Button>
  );
};

export default Blue_Outline_Btn;
